import {
    GET_CAMERA_CODE,
    // AUTO_ACTIVE,
    GET_LIST_CAMERA,
    GET_LIST_CAMERA_PRIORITY,
    GET_LIST_CODE_CAMERA,
    GET_LIST_WAREHOUSE,
    GET_PATH_NOTIFICATION,
    GET_USER_NAME, GET_USER_TYPE, GET_VIEW_PORT, REDIRECT_FOCUS, RE_GET_NOTIFICATION,
    SET_DATA_REGISTER, SET_EMAIL_FORGOT_PASS,
    SET_TOKEN_USER,
    SET_USER_PENDING_ACCEPT,
    SEARCH_CAM_PLAYBACK,
    SET_FILTER_CAMERA,
    SET_LIST_SERVICE,
    GET_AVATAR_HEADER,
    SET_SELECTED_AI_ALERT
} from "./Constants";

export const setDataRegister = (payload) => ({
    type: SET_DATA_REGISTER,
    payload
})

export const setEmailForgotPassword = (payload) => ({
    type: SET_EMAIL_FORGOT_PASS,
    payload
})

export const setTokenUser = (payload) => ({
    type: SET_TOKEN_USER,
    payload
})

export const getListCamera = (payload) => ({
    type: GET_LIST_CAMERA,
    payload
})

export const reGetNotification = () => ({
    type: RE_GET_NOTIFICATION,
})

export const getUserName = (payload) => ({
    type: GET_USER_NAME,
    payload
})

export const getListCameraPriority = (payload) => ({
    type: GET_LIST_CAMERA_PRIORITY,
    payload
})

export const focusOnRedirect = (payload) => ({
    type: REDIRECT_FOCUS,
    payload
})

export const getListWareHouse = (payload) => ({
    type: GET_LIST_WAREHOUSE,
    payload,
})

export const getViewPort = (payload) => ({
    type: GET_VIEW_PORT,
    payload
})

export const getUserType = (payload) => ({
    type: GET_USER_TYPE,
    payload
})

export const getCameraCode = (payload) => ({
    type: GET_CAMERA_CODE,
    payload
})

export const getListCodeCamera = (payload) => ({
    type: GET_LIST_CODE_CAMERA,
    payload
})
export const getPathNotification = (payload) => ({
    type: GET_PATH_NOTIFICATION,
    payload
})
export const setUserPendingAc = (payload) => ({
    type: SET_USER_PENDING_ACCEPT,
    payload
})
export const setSearchCamPlayback = (payload) => ({
    type: SEARCH_CAM_PLAYBACK,
    payload
})
export const setFilterCamera = (payload) => ({
    type: SET_FILTER_CAMERA,
    payload
})
export const setListService = (payload) => ({
    type: SET_LIST_SERVICE,
    payload
})
export const getAvatarHeader = (payload) => ({
    type: GET_AVATAR_HEADER,
    payload
})
export const setSelectedAiAlert = (payload) => ({
    type: SET_SELECTED_AI_ALERT,
    payload
})